// 针对1元训练营的购买结果页

<template>
  <div class="promote">
    <img class="promote-bg" :src="qrcode" alt="" />
    <!-- <img class="promote-qrcode" :src="qrcode" alt="" /> -->
  </div>
</template>

<script>

  // import os from '@edu-fe/os'
  import api from '@edu-fe/api'

  export default {
    data () {
      return {
        bg: '',
        qrcode: ''
      }
    },

    async mounted () {
      const { courseId, refreshCount = 0, from = '' } = this.$route.query
      const count = parseInt(refreshCount)

      // if (count < 3) {
      //   return setTimeout(() => {
      //     window.location.replace(`/sign-up-result-for-promote?courseId=${this.courseId}&from=${from}&refreshCount=${count + 1}`)
      //   }, 30)
      // }

      const { data } = await api.signUp.promoteInfo({ courseId })
      if (!data) {
        this.$router.replace(`/sign-up-result-ok2?courseId=${courseId}&from=${from}`)
        return
      }
      if (data.joinGroupUrl) {
        window.location.href = data.joinGroupUrl
      } else if (data.joinGroupQrcode) {
        // this.bg = data.backGroundImage
        this.qrcode = data.joinGroupQrcode
        window.document.title = '请入群学习'
      } else {
        this.$router.push(`/sign-up-result-ok2?courseId=${courseId}&from=${from}`)
      }
    }
  }

</script>

<style lang="scss">

@charset "UTF-8";
@import "../style/main";

.promote {
  position: relative;
  width: 100%;

  &-bg {
    display: block;
    width: 100%;
  }

  // &-qrcode {
  //   $w: use(370);
  //   position: absolute;
  //   top: use(460);
  //   width: $w;
  //   left: 50%;
  //   margin-left: - $w / 2;
  // }
}

</style>
